"use strict";
/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-11-30.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelEngineEvent = void 0;
class ReelEngineEvent {
}
// When the reel is starting, send this event.
ReelEngineEvent.REEL_SPIN_START = "reelEngine_reelSpinStart";
// When reel has started to stop.
ReelEngineEvent.REEL_STOP_SPIN_STARTED = "reelEngine_reelStopSpinStarted";
ReelEngineEvent.REEL_STOP_SPIN_BOUNCE_STARTED = "reelEngine_reelStopSpinBounceStarted";
// When all the attention and other single reel stop animation complete.
ReelEngineEvent.REEL_STOP_COMPLETED = "reelEngine_reelStopSpinCompleted";
// For add more spin time to a reel while spinning.
ReelEngineEvent.REEL_SET_CURRENT_REEL_SET = "reelEngine_setCurrentReelSet";
ReelEngineEvent.REEL_RESIZED = "reelEngine_resized";
ReelEngineEvent.REEL_NUDGE = "reelEngine_reelnudge";
ReelEngineEvent.REEL_NUDGE_COMPLETED = "reelEngine_reelnudge_completed";
exports.ReelEngineEvent = ReelEngineEvent;
//# sourceMappingURL=ReelEngineEvent.js.map